<div class="dialogGeneral">

    <div class="header">
        <i-tabler *ngIf="type=='attentionInfo' || type=='attentionInfo2' || type=='validation'" name="info-circle"
            class="icon-18 icono"></i-tabler>

        <p>{{headerText}}</p>
        <i-tabler name="x" *ngIf="type!='classCreated'" class="icon-18 iconoGray" style="cursor: pointer; color:white"
            (click)="close('')"></i-tabler>
    </div>

    <div class="body"
        *ngIf="type!='qrsDownload' && type!='qrPreview' && type!='groupClassification' && type!='classCreated'">
        <p style="width: 100%; margin:0px"
            [ngStyle]="{'text-align': type=='information' || type=='recoverPassword' ? 'center' : 'left' }" [innerHTML]="generalText"></p>
        <p *ngIf="subText!=''" style="width: 100%;">{{subText}}</p>

        <div *ngIf="type=='educatorCreation'" style="width: 100%;">
            <form class="m-t-12" [formGroup]="educatorsData" class="form">

                <div id="section">
                    <p class="darkGrey size12 category">{{'selectedSchool.school' | translate}}</p>
                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                        <input matInput formControlName="name" required />
                    </mat-form-field>
                </div>

                <div id="section">
                    <p class="darkGrey size12 category">{{'selectedSchool.numberQRs' | translate}}</p>
                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                        <input matInput type="number" min="1" max="50" formControlName="numberQRs" required />
                    </mat-form-field>
                    <mat-error
                        [ngStyle]="{opacity: educatorsData.controls.numberQRs.touched && (educatorsData.controls.numberQRs.value==null || (educatorsData.controls.numberQRs.value!=null && (educatorsData.controls.numberQRs.value==0 || educatorsData.controls.numberQRs.value>50))) ? '1' : '0' }"
                        style="font-size: 10px">{{ 'selectedSchool.errorQrs' | translate}}</mat-error>
                </div>

            </form>


        </div>

        <div *ngIf="type=='studentsCreation'" style="width: 100%;">
            <form class="m-t-12" [formGroup]="studentsData" class="form">

                <div id="section" class="qrCreation">
                    <p class="darkGrey size12 category">{{'selectedSchool.class' | translate}}</p>
                    <mat-form-field appearance="outline" class="w-100 hide-hint" *ngIf="selectedClass">
                        <input matInput formControlName="name" required />
                    </mat-form-field>

                    <mat-form-field class="w-100" *ngIf="availableClasses" [ngClass]="{
                        'error': userOpenedSelect && studentsData.get('name')?.hasError('required'),
                        'noError': (userOpenedSelect && !studentsData.get('name')?.hasError('required')) || (!userOpenedSelect)
                      }">

                        <mat-select formControlName="name" (opened)="onOpened()" (closed)="onClosed()" required>
                            <mat-option value="{{item.classId}}" style="font-size: 13px"
                                *ngFor="let item of availableClasses">{{item.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-error
                        [ngStyle]="{opacity: userOpenedSelect && studentsData.get('name')?.hasError('required') ? '1' : '0' }"
                        style="font-size: 10px">{{ 'selectedSchool.errorClass' | translate}}</mat-error>
                </div>

                <div id="section">
                    <p class="darkGrey size12 category">{{'selectedSchool.numberQRs' | translate}}</p>
                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                        <input matInput type="number" min="1" max="50" formControlName="numberQRs" required />
                    </mat-form-field>
                    <mat-error
                        [ngStyle]="{opacity: studentsData.controls.numberQRs.touched && (studentsData.controls.numberQRs.value==null || (studentsData.controls.numberQRs.value!=null && (studentsData.controls.numberQRs.value==0 || studentsData.controls.numberQRs.value>50))) ? '1' : '0' }"
                        style="font-size: 10px">{{ 'selectedSchool.errorQrs' | translate}}</mat-error>
                </div>

            </form>


        </div>

        <div *ngIf="type=='recoverPassword'" style="width: 100%; margin-top: 12px;">
            <form class="m-t-12" [formGroup]="userEmail" class="form" style="justify-content: center;">

                <div id="section" style="width: 80%;">
                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                        <input matInput formControlName="email" />

                    </mat-form-field>

                    
                    <div class="error" [ngStyle]="{ opacity: (userEmailControls['email'].touched && userEmailControls['email'].invalid) ? '1' : '0', visibility: (userEmailControls['email'].touched && userEmailControls['email'].invalid) ? 'visible' : 'hidden'}">
                        @if(userEmailControls['email'].errors?.['required']) {
                        <div>
                            {{ "login.emailRequired" | translate }}
                        </div>

                        }
                        @if(userEmailControls['email'].errors?.['email']) {
                        <div>
                            {{ "login.emailFormatError" | translate }}
                        </div>
                        }
                    </div>

                    


                </div>

            </form>


        </div>


        <div id="buttons" *ngIf="type=='groupClassification'|| type=='information' || type=='attentionInfo' || type=='attentionInfo2'">
            <button mat-flat-button *ngFor="let eachButton of button; let i=index" (click)="close(i)"
                class="blueButton buttonFilled">{{eachButton}}</button>
        </div>

        <div id="buttons" *ngIf="type=='recoverPassword'">
            <button mat-flat-button *ngFor="let eachButton of button; let i=index"
                (click)="close(userEmail.controls.email.value)" class="blueButton buttonFilled"
                [ngStyle]="{ opacity: userEmail.controls['email'].valid ? '1' : '0.5' }"
                [disabled]="userEmail.controls['email'].invalid">{{eachButton}}</button>
        </div>

        <div id="buttons" *ngIf="type=='educatorCreation'" style="justify-content: flex-end;">
            <button mat-flat-button (click)="close('')" class="redRoundButton buttonFilled">{{button[0]}}</button>
            <button
                [disabled]="educatorsData.controls.numberQRs.value==0 || educatorsData.controls.numberQRs.value==null"
                [ngClass]="{'disabled': educatorsData.controls.numberQRs.value==0 || educatorsData.controls.numberQRs.value==null }"
                mat-flat-button (click)="close(educatorsData.controls.numberQRs.value)"
                class="greenRoundButton buttonFilled">{{button[1]}}</button>
        </div>

        <div id="buttons" *ngIf="type=='studentsCreation'" style="justify-content: flex-end;">
            <button mat-flat-button (click)="close('')" class="redRoundButton buttonFilled">{{button[0]}}</button>
            <button *ngIf="selectedClass"
                [disabled]="studentsData.controls.numberQRs.value==0 || studentsData.controls.numberQRs.value==null"
                [ngClass]="{'disabled': studentsData.controls.numberQRs.value==0 || studentsData.controls.numberQRs.value==null }"
                mat-flat-button (click)="close(studentsData.controls.numberQRs.value)"
                class="greenRoundButton buttonFilled">{{button[1]}}</button>
            <button *ngIf="availableClasses"
                [disabled]="studentsData.controls.numberQRs.value==0 || studentsData.controls.numberQRs.value==null || studentsData.controls.name.value==''"
                [ngClass]="{'disabled': studentsData.controls.numberQRs.value==0 || studentsData.controls.numberQRs.value==null || studentsData.controls.name.value=='' }"
                mat-flat-button
                (click)="closeStudentsCreation(studentsData.controls.name.value, studentsData.controls.numberQRs.value)"
                class="greenRoundButton buttonFilled">{{button[1]}}</button>
        </div>

        <div id="buttons" *ngIf="type=='qrsDownload'" style="justify-content: flex-end;">
            <button mat-flat-button (click)="close('')" class="redRoundButton buttonFilled">{{button[0]}}</button>
            <button mat-flat-button (click)="close('generateZip')"
                class="greenRoundButton buttonFilled">{{button[1]}}</button>
        </div>

        <div id="buttons" *ngIf="type=='validation'" style="justify-content: flex-end;">
            <button mat-flat-button (click)="close('0')" class="redRoundButton buttonFilled">{{button[0]}}</button>
            <button mat-flat-button (click)="close('1')" class="blueRoundButton buttonFilled">{{button[1]}}</button>
        </div>
    </div>

    <!-- QRS CREATION -->

    <div class="body" *ngIf="type=='qrsDownload' || type=='qrPreview'">

        <div id="subBody">
            <div>
                <img *ngIf="type!='qrPreview'" style="height: 75px;padding-right: 20px;"
                    src="assets/images/fakeQR.png" />
                <img *ngIf="type=='qrPreview'" style="height: 75px;padding-right: 20px;" src="{{userQrLink}}" />
            </div>
            <div>
                <p style="width: 100%; margin: 0px;">{{generalText}}</p>
                <p *ngIf="subText!=''" style="width: 100%; margin:0px;font-size:11px;color: #768B9E;">{{subText}}</p>
            </div>
        </div>

        <div *ngIf="type!='qrPreview'" id="buttons" style="justify-content: flex-end;">
            <button mat-flat-button (click)="close('')" class="blueRoundButton buttonFilled">{{button[0]}}</button>
            <button mat-flat-button (click)="close('generateZip')"
                class="greenRoundButton buttonFilled">{{button[1]}}</button>
        </div>

        <div *ngIf="type=='qrPreview'" id="buttons" style="justify-content: flex-end;">
            <button mat-flat-button (click)="close('')" class="blueRoundButton buttonFilled">{{button[0]}}</button>
            <button mat-flat-button (click)="close('downloadQR')"
                class="greenRoundButton buttonFilled">{{button[1]}}</button>
        </div>
    </div>

    <!-- GROUP CLASIFICATION -->

    <div class="body" *ngIf="type=='groupClassification'">

        <div class="contentForm">

            <div class="classInfo">
                <p style="margin:0px">
                    <span class="darkGrey" style="margin-right: 15px">{{'selectedSchool.class' | translate}}
                        {{classData.class}}</span>
                    <span class="blue">
                        {{'selectedSchool.level' | translate}}
                    </span>
                    <span *ngIf="classData.level==1" class="subtitle2">{{'selectedSchool.level1' | translate}}</span>
                    <span *ngIf="classData.level==2" class="subtitle2">{{'selectedSchool.level2' | translate}}</span>
                    <span *ngIf="classData.level==3" class="subtitle2">{{'selectedSchool.level3' | translate}}</span>
                    <span class="blue" style="margin-right: 2px; margin-left: 15px;">
                        {{'selectedSchool.age' | translate}}
                    </span>
                    <span class="subtitle2">
                        {{classData.age.from}}-{{classData.age.to}} {{'selectedSchool.yearsOld' | translate}}
                    </span>
                </p>
            </div>
            <form [formGroup]="groupSelection">

                <div class="titles">
                    <p class="elementTitle">{{'selectedSchool.study' | translate}}</p>
                    <p class="elementTitle" style="padding-left: 20px;">{{'selectedSchool.group' | translate}}</p>
                </div>

                <div class="groupSelection">

                    <div class="element"
                        [ngClass]="{'error':groupSelection.controls.study.errors && studyVerified,'noError':!(groupSelection.controls.study.errors && studyVerified)}">

                        <mat-form-field class="w-100">
                            <mat-select formControlName="study">
                                <mat-option [value]="0"><span style="font-size: 13px">{{'selectedSchool.study1' |
                                        translate}} ({{'selectedSchool.syudy1Description' |
                                        translate}})</span></mat-option>
                                <mat-option [value]="1"><span style="font-size: 13px">{{'selectedSchool.study2' |
                                        translate}} ({{'selectedSchool.syudy2Description' |
                                        translate}})</span></mat-option>
                            </mat-select>

                        </mat-form-field>
                        <mat-error
                            [ngStyle]="{opacity: (groupSelection.controls.study.errors && studyVerified) ? '1' : '0' }"
                            style="font-size: 10px">{{ 'selectedSchool.groupSelectionError' | translate}}</mat-error>

                    </div>

                    <div class="element" style="padding-left: 20px;"  [ngClass]="{'error':groupSelection.controls.group.errors && studyVerified,'noError':!(groupSelection.controls.group.errors && studyVerified)}">
                           <mat-radio-group aria-label="Select an option" formControlName="group" [disabled]="classData.interventionStarted" style="display: flex; flex-direction: row;">
                                <mat-radio-button [value]="1">{{'home.control' | translate}}</mat-radio-button>
                                <mat-radio-button [value]="2" style="padding-left: 20px;">{{'home.intervention' | translate}}</mat-radio-button>
                           </mat-radio-group>

                       <mat-error [ngStyle]="{opacity: (groupSelection.controls.group.errors && studyVerified) ? '1' : '0' }" style="font-size: 10px">{{ 'selectedSchool.groupSelectionErrorGroup' | translate}}</mat-error>


                    </div>
                </div>

            </form>
        </div>


        <div id="buttons" style="justify-content: flex-end;">

            <button mat-flat-button (click)="close('')" class="redRoundButton buttonFilled">{{button[0]}}</button>
            <button *ngIf="button.length==2 || (button.length==3 && clickedEdit)" mat-flat-button (click)="saveGroupSelection()" class="greenRoundButton buttonFilled"
             [ngClass]="{'disabled': (groupSelection.controls['study'].value!==0 && groupSelection.controls['study'].value!==1) || (groupSelection.controls['group'].value!==1 && groupSelection.controls['group'].value!==2) }">{{button[1]}}</button>
            <button *ngIf="button[2] && !clickedEdit" mat-flat-button (click)="editGroupSelection()"
                class="greenRoundButton buttonFilled"
                [ngClass]="{'disabled': (groupSelection.controls['study'].value!==0 && groupSelection.controls['study'].value!==1) || (groupSelection.controls['group'].value!==1 && groupSelection.controls['group'].value!==2) }">{{button[2]}}</button>
        </div>

    </div>


    <!-- CLASS CREATED -->
    <div class="body" *ngIf="type=='classCreated'">
        <div id="content" style="height: 100%;">
            <div style="width: 100%;">
                <p id="title">{{'selectedSchool.class' | translate}} {{className}} {{'newClass.isCreated' | translate}}
                </p>
            </div>
            <div style="width: 100%; display: flex; padding-top: 10px;">
                <div style="width: 60%;">
                    <p id="subtitle" style="width: 100%; margin: 0px;">{{generalText}}</p>
                </div>
                <div style="width: 40%; display: flex; flex-direction: column; align-items: stretch;">
                    <img style="width: 100%; padding-left: 20px;padding-right: 20px; margin-bottom: 10px;"
                        src="/assets/images/logos/sunriseLogoComplete.png" />

                    <button mat-flat-button (click)="close('')" class="blueRoundButton buttonFilled"
                        style="margin-bottom: 0px;">{{button[0]}}</button>
                </div>
            </div>
        </div>



    </div>




</div>